var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-dialog-header"},[_c('div',{staticClass:"custom-dialog-title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('button',{staticClass:"fullscreen-btn",attrs:{"type":"button"},on:{"click":_vm.toggleFullscreen}},[_c('i',{staticClass:"fullscreen-icon el-icon",class:_vm.fullscreenIcon})])])
}
var staticRenderFns = []

export { render, staticRenderFns }